export const DIV_SWITCHED = 'divSwitched';
